import "./main.css";
import {useSlotProps as $aBEni$useSlotProps, useDOMRef as $aBEni$useDOMRef, useStyleProps as $aBEni$useStyleProps, classNames as $aBEni$classNames} from "@react-spectrum/utils";
import $aBEni$react from "react";
import {useSeparator as $aBEni$useSeparator} from "@react-aria/separator";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

var $7a9eac509b76fa30$exports = {};

$parcel$export($7a9eac509b76fa30$exports, "focus-ring", () => $7a9eac509b76fa30$export$f39a09f249340e2a, (v) => $7a9eac509b76fa30$export$f39a09f249340e2a = v);
$parcel$export($7a9eac509b76fa30$exports, "i18nFontFamily", () => $7a9eac509b76fa30$export$8c4ee2c50c22c514, (v) => $7a9eac509b76fa30$export$8c4ee2c50c22c514 = v);
$parcel$export($7a9eac509b76fa30$exports, "spectrum-FocusRing-ring", () => $7a9eac509b76fa30$export$4109102f950813a6, (v) => $7a9eac509b76fa30$export$4109102f950813a6 = v);
$parcel$export($7a9eac509b76fa30$exports, "spectrum-FocusRing", () => $7a9eac509b76fa30$export$24c7f46a6e3605dd, (v) => $7a9eac509b76fa30$export$24c7f46a6e3605dd = v);
$parcel$export($7a9eac509b76fa30$exports, "spectrum-FocusRing--quiet", () => $7a9eac509b76fa30$export$2927016961429360, (v) => $7a9eac509b76fa30$export$2927016961429360 = v);
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule", () => $7a9eac509b76fa30$export$9ebf9cdaed6878bc, (v) => $7a9eac509b76fa30$export$9ebf9cdaed6878bc = v);
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule--horizontal", () => $7a9eac509b76fa30$export$563c1b24466c05b8, (v) => $7a9eac509b76fa30$export$563c1b24466c05b8 = v);
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule--large", () => $7a9eac509b76fa30$export$243baa0ec4ab58cc, (v) => $7a9eac509b76fa30$export$243baa0ec4ab58cc = v);
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule--medium", () => $7a9eac509b76fa30$export$a8d73b58ca350eb9, (v) => $7a9eac509b76fa30$export$a8d73b58ca350eb9 = v);
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule--small", () => $7a9eac509b76fa30$export$b4b727880cfe37d, (v) => $7a9eac509b76fa30$export$b4b727880cfe37d = v);
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule--vertical", () => $7a9eac509b76fa30$export$76f93463a8fc15a8, (v) => $7a9eac509b76fa30$export$76f93463a8fc15a8 = v);
var $7a9eac509b76fa30$export$f39a09f249340e2a;
var $7a9eac509b76fa30$export$8c4ee2c50c22c514;
var $7a9eac509b76fa30$export$4109102f950813a6;
var $7a9eac509b76fa30$export$24c7f46a6e3605dd;
var $7a9eac509b76fa30$export$2927016961429360;
var $7a9eac509b76fa30$export$9ebf9cdaed6878bc;
var $7a9eac509b76fa30$export$563c1b24466c05b8;
var $7a9eac509b76fa30$export$243baa0ec4ab58cc;
var $7a9eac509b76fa30$export$a8d73b58ca350eb9;
var $7a9eac509b76fa30$export$b4b727880cfe37d;
var $7a9eac509b76fa30$export$76f93463a8fc15a8;
$7a9eac509b76fa30$export$f39a09f249340e2a = `cTbPrq_focus-ring`;
$7a9eac509b76fa30$export$8c4ee2c50c22c514 = `cTbPrq_i18nFontFamily`;
$7a9eac509b76fa30$export$4109102f950813a6 = `cTbPrq_spectrum-FocusRing-ring`;
$7a9eac509b76fa30$export$24c7f46a6e3605dd = `cTbPrq_spectrum-FocusRing ${$7a9eac509b76fa30$export$4109102f950813a6}`;
$7a9eac509b76fa30$export$2927016961429360 = `cTbPrq_spectrum-FocusRing--quiet`;
$7a9eac509b76fa30$export$9ebf9cdaed6878bc = `cTbPrq_spectrum-Rule`;
$7a9eac509b76fa30$export$563c1b24466c05b8 = `cTbPrq_spectrum-Rule--horizontal`;
$7a9eac509b76fa30$export$243baa0ec4ab58cc = `cTbPrq_spectrum-Rule--large`;
$7a9eac509b76fa30$export$a8d73b58ca350eb9 = `cTbPrq_spectrum-Rule--medium`;
$7a9eac509b76fa30$export$b4b727880cfe37d = `cTbPrq_spectrum-Rule--small`;
$7a9eac509b76fa30$export$76f93463a8fc15a8 = `cTbPrq_spectrum-Rule--vertical`;



let $269e81ee206e9515$var$sizeMap = {
    S: "small",
    M: "medium",
    L: "large"
};
function $269e81ee206e9515$var$Divider(props, ref) {
    props = (0, $aBEni$useSlotProps)(props, "divider");
    let { size: size = "L", orientation: orientation = "horizontal", ...otherProps } = props;
    let domRef = (0, $aBEni$useDOMRef)(ref);
    let { styleProps: styleProps } = (0, $aBEni$useStyleProps)(otherProps);
    let weight = $269e81ee206e9515$var$sizeMap[size];
    let Element = "hr";
    if (orientation === "vertical") Element = "div";
    let { separatorProps: separatorProps } = (0, $aBEni$useSeparator)({
        ...props,
        elementType: Element
    });
    return /*#__PURE__*/ (0, $aBEni$react).createElement(Element, {
        ...styleProps,
        className: (0, $aBEni$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($7a9eac509b76fa30$exports))), "spectrum-Rule", `spectrum-Rule--${weight}`, {
            "spectrum-Rule--vertical": orientation === "vertical",
            "spectrum-Rule--horizontal": orientation === "horizontal"
        }, styleProps.className),
        // @ts-ignore https://github.com/Microsoft/TypeScript/issues/28892
        ref: domRef,
        ...separatorProps
    });
}
/**
 * Dividers bring clarity to a layout by grouping and dividing content in close proximity.
 * They can also be used to establish rhythm and hierarchy.
 */ let $269e81ee206e9515$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $aBEni$react).forwardRef($269e81ee206e9515$var$Divider);




export {$269e81ee206e9515$export$2e0a83ec2e27ecbb as Divider};
//# sourceMappingURL=module.js.map
